export default __webpack_public_path__ + "static/6852-383e6860b08b210f0503646cb98e239e.jpg";